<template>
  <layout>
    <page-header :actions="actions" :header="$t('airports.title')" />
    <div class="content">
      <admin-table
        v-if="currentDivision"
        ref="table"
        v-bind="tableProps"
      ></admin-table>
    </div>
  </layout>
</template>

<script>
import { AdminTable } from 'stylemix-vue-admin'
import AirportsApi from './Api'

const resourceBase = 'airports'

export default {
  name: 'AirportsIndex',

  components: {
    AdminTable,
  },

  data() {
    return {
      // Table resource configuration
      tableProps: {
        base: resourceBase,
        apiBuilder: () => {
          return new AirportsApi({
            include: 'division',
          })
        },
        sortBy: 'order',
        sortDesc: false,
        perPage: 9,
        columns: [
          {
            key: 'id',
            label: this.$t('airports.id'),
            sortable: true,
          },
          {
            key: 'name',
            label: this.$t('airports.name'),
            sortable: true,
          },
          {
            key: 'division_name',
            label: this.$t('airports.division_name'),
          },
          {
            key: 'location.address',
            label: this.$t('airports.address'),
          },
          {
            key: 'location.latlng',
            label: this.$t('airports.location'),
          },
          {
            key: 'created_at',
            label: this.$t('airports.created'),
            sortable: true,
            formatter: (value) => {
              return this.$moment(value).format('lll')
            },
          },
        ],

        // override search fields here using fields schema
        // searchFields: [
        // ],

        // define custom row actions
        rowActions: () => {
          let actions = []

          if (
            this.$allows(`${resourceBase}.update`) ||
            this.$allows(`${resourceBase}.view`)
          ) {
            actions.push('edit')
          }
          if (this.$allows(`${resourceBase}.delete`)) {
            actions.push('delete')
          }

          return actions
        },

        // define custom bulk actions
        bulkActions() {
          return []
        },
      },
    }
  },

  computed: {
    // Page header actions
    actions() {
      if (this.$allows(`${resourceBase}.create`)) {
        return [
          {
            id: 'create',
            text: this.$t('general.add_new'),
            icon: 'icon-plus-circle2',
            onClick: () => {
              // eslint-disable-next-line vue/no-side-effects-in-computed-properties
              this.$router.push({
                name: `${resourceBase}.create`,
              })
            },
          },
        ]
      } else {
        return []
      }
    },
  },
}
</script>
